// extracted by mini-css-extract-plugin
export default {"container":"Mailfails_container__FPVc5","info":"Mailfails_info__58f9q","count":"Mailfails_count__NHK2x"};